// ********************************************************
// Unloading fuel
// Handles stuff like view and submit weights from Unloading fuel.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'UnloadFuel.LoadItems',
    inputData: {
      Facility: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadrecentRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'UnloadFuel.LoadRecentRegistrations',
    inputData: {
      Facility: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'UnloadFuel.LoadItem',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadActiveRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'UnloadFuel.ActiveUnloadingFuelRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function saveRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'UnloadFuel.SaveItem',
    inputData: {
      UnloadingFuelItem: params
    }
  })
  return res
}

export async function CancelRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'UnloadFuel.CancelRecentRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}
